import { z } from "zod";
import { ZProjectNo } from "./foundationSchema";
import { ZRoomValidationSpecifiedArticles } from "./room/specifiedArticlesSchema";
export const ZDrofusRoomOccurrenceValidationRequest = z.object({
    projectNo: ZProjectNo,
    roomNumber: z.string().trim().min(1),
});
export const ZDrofusRoomOccurrenceValidationResponse = z.object({
    ok: z.literal(true),
    projectNo: ZProjectNo,
    roomNumber: z.string(),
    validatedAt: z.string().datetime(),
    elapsedMs: z.number().int().nonnegative(),
    validation: ZRoomValidationSpecifiedArticles.nullable(),
});
